export default __webpack_public_path__ + "static/media/paige-page.37ad8fea.png";